/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\SeenCar\SeenCarRow\SeenCarRow.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday December 21st 2023
 * Author: Jonathan MAZAT
 * -----
 * Last Modified: Thursday December 21st 2023 4:14:04 pm
 * Modified By: the developer formerly known as Jonathan MAZAT at <you@you.you>
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { TableCell, TableRow } from "@mui/material"
import RouterPathResolver from "Config/Router/RouterPathResolver"
import { Link } from "react-router-dom"

export type SeenCarType ={
    Date: string,
    User: {
        id: string,
        FirstName: string,
        LastName: string,
        Commercial: {
            FirstName: string,
            LastName: string,
        },
        Company: {
            Name: string,
        }
    },
    NbView: number,
    Car: {
        id: string,
        RegNb: string,
        Brand: string,
        Model: string,
        Version: string,
    },
    // InSell: {
    //     Sell: {
    //         Name: string
    //     }
    // }
}

function SeenCarRow (props: SeenCarType) {
    const tmpDate = new Date(props.Date);
    const client = `${props.User.LastName} ${props.User.FirstName} (${props.User.Company.Name})`;

    return (
        <TableRow hover>
            <TableCell align="center" className="text-uppercase">
                <Link to={RouterPathResolver.pathCar_BY_ID.path.replace(":id", props.Car.id)}>
                    {props.Car.RegNb} / {props.Car.Brand} {props.Car.Model}
                </Link>
            </TableCell>
            <TableCell align="center" className="text-capitalize">
                <Link to={RouterPathResolver.pathUser_BY_ID.path.replace(":id", props.User.id)}>
                    {client}
                </Link>
            </TableCell>
            <TableCell align="center" className="text-capitalize">{props.User.Commercial.FirstName} {props.User.Commercial.LastName}</TableCell>
            <TableCell align="center" className="text-capitalize">{tmpDate.toLocaleDateString()} {tmpDate.toLocaleTimeString()}</TableCell>
            {/* <TableCell align="center" className="text-capitalize">{props.InSell.Sell.Name}</TableCell> */}
            <TableCell align="center" className="text-capitalize">{props.NbView}</TableCell>
        </TableRow>
    )
}

export default SeenCarRow;
